<template>
  <div class="brief-marcas-datos">
    <!-- <b-table
        :key="key"
        hover
        responsive="sm" 
        class="registro"
        :items="marcas" 
        :fields="fields">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>
    </b-table> -->

    <div class="subtitulo">
      <label>Marcas Incluidas</label>
    </div>

    <b-list-group :key="key" flush>
      <b-list-group-item v-for="marca in marcas" :key="marca.marca">
        {{ marca.marca }}
      </b-list-group-item>
    </b-list-group> 

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefDatos/getField',
  mutationType: 'briefDatos/updateField',
});

export default {
  name: 'BriefMarcasData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      key: 0,

      fields: [
        { key: 'marca' },
      ],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'marcas',
    ]),
  },  
  created() {

  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    }
  },
  watch: {
  }    
}
</script>

<style>
  .brief-marcas-datos {
    min-height: 300px;
  }
</style>